import { Box, Paper, Text, Title } from "@mantine/core";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  ResponsiveContainer,
} from "recharts";

import { LikeResponse } from "../../../entities/components/LikeResponse";
import { InfoIcon } from "../../../shared/svg";
import { useMediaQuery } from "@mantine/hooks";
import useReportStore from "../../../store/useReportStore";

const CustomTooltip: React.FC<{ active?: boolean; payload?: any[] }> = ({
  active,
  payload,
}) => {
  if (active && payload && payload.length) {
    return (
      <Paper w={279} p={24} radius={8} shadow="0px -20px 80px 0px #0000000a">
        <Text>{payload[0].payload.info}</Text>
      </Paper>
    );
  }

  return null;
};

export const TopTalents = () => {
  const matches = useMediaQuery("(max-width: 1100px)");
  const { report, reportId } = useReportStore();

  const talentsData = report?.talents || [];

  const content = talentsData.data.map((talent, index) => ({
    name: talent.title,
    value: talent.percentage,
    info: talent.description,
    fill:
      index % 5 === 0
        ? "#6e40e2"
        : index % 5 === 1
        ? "#05D8D2"
        : index % 5 === 2
        ? "#3A8BD9"
        : index % 5 === 3
        ? "#A64DD7"
        : "#DE57CC",
    description: talent.description,
  }));

  const CustomLabel: React.FC<any> = (props) => {
    const { x, y, width, height, name } = props;

    return (
      <foreignObject x={x} y={y} width={width} height={height}>
        <Box
          component="div"
          w={width}
          h={height}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingLeft: 12,
            paddingRight: 12,
            boxSizing: "border-box",
            color: "#fff",
            fontSize: matches ? "16px" : "24px",
            fontWeight: 600,
          }}
        >
          <Text
            style={{ fontSize: matches ? "16px" : "24px" }}
            fw={600}
            truncate
          >
            {name}
          </Text>
          <Box w={24} h={24} ml={8}>
            <InfoIcon />
          </Box>
        </Box>
      </foreignObject>
    );
  };

  return (
    <Paper radius="24px" p="32px" mt={32} withBorder>
      <Title size={matches ? 24 : 36} mb={8}>
        {talentsData?.mark_down
          ? talentsData?.mark_down.replace("##", "")
          : "Title"}
      </Title>
      <Text style={{ fontSize: matches ? 16 : 18 }} mb={24} c="dimmed">
        {talentsData?.explanation}
      </Text>
      <ResponsiveContainer width="100%" height={567}>
        <BarChart data={content} layout="vertical">
          <CartesianGrid horizontal={false} />
          <XAxis
            type="number"
            tickFormatter={(tick) => `${tick}%`}
            interval={0}
            ticks={
              matches
                ? [0, 20, 40, 60, 80, 100]
                : [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
            }
          />
          <YAxis type="category" dataKey="name" width={0} tick={false} />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="value" isAnimationActive={false} radius={[8, 8, 8, 8]}>
            <LabelList dataKey="value" content={CustomLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <LikeResponse report_id={reportId} section="talents" />
    </Paper>
  );
};
